import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessVersionStartProcessVersionPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessVersionStartProcessVersionProperties = {
    [name in keyof EntityCommandProcessVersionStartProcessVersionPropertyValues]: Property<EntityCommandProcessVersionStartProcessVersionPropertyValues[name]>
};

export interface IEntityCommandProcessVersionStartProcessVersion extends IEntityCommand, EntityCommandProcessVersionStartProcessVersionProperties
{
}

export class EntityCommandProcessVersionStartProcessVersion extends EntityCommand implements IEntityCommandProcessVersionStartProcessVersion
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessVersionStartProcessVersion";
    public static override className = "EntityCommandProcessVersionStartProcessVersion";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessVersionStartProcessVersionPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Start Process Version",
                entityName: "ProcessVersion",
                key: "START_PROCESS_VERSION",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessVersionStartProcessVersionPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        record = entityCommandInformation.record.get();

                    if (!record?.id)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: "b185975f-0e14-4944-b706-6353f0d67dc4",
                                    operation: "StartProcess",
                                    data: ObjectHelper.toJson({
                                        processVersionId: record.id,
                                        synchronousContinuation: true
                                    })
                                }
                            )
                            .executeAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
    }

